export interface PickerOption {
	id: string;
	title: string;
}

export interface Condition {
	id: string;
	title: string;
	type: string;
}

export interface Operation {
	operation: string;
	result: boolean;
	title: string;
}
export interface OperationPickerOption extends Operation, PickerOption {
}

export interface ConditionPickerOption extends Condition, PickerOption {
	icon?: string;
}

export enum ConditionDataType {
	Text = 'text',
	Number = 'number',
	DateTime = 'datetime',
	Date = 'date',
	Decimal = 'decimal',
	List = 'list',
	Duration = 'duration',
	Intent = 'intent',
}

export enum ConditionOperationType {
	Equals = 'equals',
	Contains = 'contains',
	GreaterThan = 'greaterThan',
	LessThan = 'lessThan',
	IsSet = 'isSet',
}

const operations: {[key: string]: Operation[]} = {
	text: [
		{
			title: 'is',
			operation: ConditionOperationType.Equals,
			result: true
		},
		{
			title: 'is not',
			operation: ConditionOperationType.Equals,
			result: false
		},
		{
			title: 'contains',
			operation: ConditionOperationType.Contains,
			result: true
		},
		{
			title: 'does not contain',
			operation: ConditionOperationType.Contains,
			result: false
		},
		{
			title: 'has a value',
			operation: ConditionOperationType.IsSet,
			result: true
		},
		{
			title: 'is unknown',
			operation: ConditionOperationType.IsSet,
			result: false
		},
	],
	datetime: [
		{
			title: 'more than',
			operation: ConditionOperationType.GreaterThan,
			result: true
		},
		{
			title: 'less than',
			operation: ConditionOperationType.LessThan,
			result: true
		},
		{
			title: 'exactly',
			operation: ConditionOperationType.Equals,
			result: true
		},
		{
			title: 'has a value',
			operation: ConditionOperationType.IsSet,
			result: true
		},
		{
			title: 'is unknown',
			operation: ConditionOperationType.IsSet,
			result: false
		},
	],
	date: [
		{
			title: 'more than',
			operation: ConditionOperationType.GreaterThan,
			result: true
		},
		{
			title: 'less than',
			operation: ConditionOperationType.LessThan,
			result: true
		},
		{
			title: 'exactly',
			operation: ConditionOperationType.Equals,
			result: true
		},
		{
			title: 'has a value',
			operation: ConditionOperationType.IsSet,
			result: true
		},
		{
			title: 'is unknown',
			operation: ConditionOperationType.IsSet,
			result: false
		},
	],
	number: [
		{
			title: 'is more than',
			operation: ConditionOperationType.GreaterThan,
			result: true
		},
		{
			title: 'is less than',
			operation: ConditionOperationType.LessThan,
			result: true
		},
		{
			title: 'is exactly',
			operation: ConditionOperationType.Equals,
			result: true
		},
		{
			title: 'is not',
			operation: ConditionOperationType.Equals,
			result: false
		},
		{
			title: 'has a value',
			operation: ConditionOperationType.IsSet,
			result: true
		},
		{
			title: 'is unknown',
			operation: ConditionOperationType.IsSet,
			result: false
		},
	],
	decimal: [
		{
			title: 'is more than',
			operation: ConditionOperationType.GreaterThan,
			result: true
		},
		{
			title: 'is less than',
			operation: ConditionOperationType.LessThan,
			result: true
		},
		{
			title: 'is exactly',
			operation: ConditionOperationType.Equals,
			result: true
		},
		{
			title: 'is not',
			operation: ConditionOperationType.Equals,
			result: false
		},
		{
			title: 'has a value',
			operation: ConditionOperationType.IsSet,
			result: true
		},
		{
			title: 'is unknown',
			operation: ConditionOperationType.IsSet,
			result: false
		},
	],
	list: [
		{
			title: 'is',
			operation: ConditionOperationType.Equals,
			result: true
		}
	],
	duration: [
		{
			title: 'is',
			operation: ConditionOperationType.Equals,
			result: true
		}
	],
	seconds: [ // Old duration name
		{
			title: 'is',
			operation: ConditionOperationType.Equals,
			result: true
		}
	],
	intent: [
		{
			title: 'is',
			operation: ConditionOperationType.Equals,
			result: true
		}
	]
};

export enum DateTimeDataTypeUnits {
	Days = 'days',
	Hours = 'hours',
	Minutes = 'minutes',
}

const dateTimeUnits: PickerOption[] = [
	{
		id: DateTimeDataTypeUnits.Days,
		title: 'days'
	},
];

export const Conditions = {
	Operations: operations,
	DateTimeUnits: dateTimeUnits,
};
